import React, { useState, useRef, useEffect } from "react";
import "./videoIntro.css";
import Video from "../../assets/video/intro.mp4";

const VideoIntro = () => {
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(true);
  const [wait, setWait] = useState(true);

  const videoRef = useRef(null);

  const handleExpand = () => {
    setOpen((prev) => {
      if (videoRef.current) {
        if (!prev) {
          videoRef.current.muted = false;
        } else {
          videoRef.current.muted = true;
        }
      }

      return !prev;
    });
  };

  const handleClose = (event) => {
    event.stopPropagation();
    videoRef.current.pause();

    setClose(true);
  };

  useEffect(() => {
    setTimeout(() => {
      setWait(false);

      setTimeout(() => {
        setClose(false);
      }, 1000);
    }, 2000);
  }, []);

  return (
    <>
      {!wait && (
        <div
          className={`video-intro ${close ? "" : "show-video"}`}
          style={{ pointerEvents: close ? "none" : "initial" }}
        >
          <div
            className={`video-wrapper ${open ? "open" : ""}`}
            onClick={handleExpand}
          >
            <svg
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="close"
              onClick={handleClose}
            >
              <circle cx="17" cy="17" r="17" fill="black" />
              <circle
                cx="17"
                cy="17"
                r="16.5"
                stroke="white"
                strokeOpacity="0.2"
              />
              <rect
                x="11.4436"
                y="22.3137"
                width="16"
                height="1"
                transform="rotate(-45 11.4436 22.3137)"
                fill="white"
              />
              <rect
                x="11.7071"
                y="11.248"
                width="16"
                height="1"
                transform="rotate(45 11.7071 11.248)"
                fill="white"
              />
            </svg>
            <video ref={videoRef} autoPlay muted playsInline loop>
              <source src={Video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            <svg
              style={{
                opacity: open ? 0 : 1,
                pointerEvents: open ? "none" : "initial",
              }}
              className="expand"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="28" height="28" rx="14" fill="black" />
              <rect
                x="0.5"
                y="0.5"
                width="27"
                height="27"
                rx="13.5"
                stroke="white"
                strokeOpacity="0.2"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.8218 9.17766C18.9657 9.32154 19.0216 9.51818 18.992 9.70443V12.5389C18.992 12.6979 18.9289 12.8504 18.8165 12.9628C18.704 13.0752 18.5515 13.1384 18.3925 13.1384C18.2335 13.1384 18.0811 13.0752 17.9686 12.9628C17.8562 12.8504 17.793 12.6979 17.793 12.5389V11.0657L15.403 13.4565C15.3466 13.5131 15.2796 13.5579 15.2058 13.5886C15.132 13.6192 15.053 13.635 14.9731 13.6351C14.8932 13.6352 14.8141 13.6195 14.7403 13.589C14.6665 13.5585 14.5994 13.5138 14.5429 13.4573C14.4864 13.4009 14.4415 13.3339 14.4109 13.2602C14.3802 13.1864 14.3644 13.1073 14.3644 13.0275C14.3643 12.9476 14.3799 12.8685 14.4104 12.7947C14.4409 12.7209 14.4857 12.6538 14.5421 12.5973L16.9321 10.2072H15.4613C15.3826 10.2072 15.3047 10.1917 15.2319 10.1616C15.1592 10.1315 15.0931 10.0873 15.0374 10.0316C14.9818 9.97595 14.9376 9.90986 14.9075 9.83713C14.8773 9.76439 14.8618 9.68644 14.8618 9.60771C14.8618 9.52898 14.8773 9.45102 14.9075 9.37828C14.9376 9.30555 14.9818 9.23946 15.0374 9.18379C15.0931 9.12812 15.1592 9.08396 15.2319 9.05383C15.3047 9.02371 15.3826 9.0082 15.4613 9.0082H18.2926C18.3878 8.99239 18.4854 8.99951 18.5773 9.02899C18.6692 9.05846 18.7535 9.10943 18.8218 9.17766ZM10.1993 15.4693C10.1993 15.3906 10.1838 15.3126 10.1536 15.2399C10.1235 15.1671 10.0793 15.1011 10.0237 15.0454C9.968 14.9897 9.90191 14.9456 9.82917 14.9154C9.75644 14.8853 9.67848 14.8698 9.59975 14.8698C9.52102 14.8698 9.44307 14.8853 9.37033 14.9154C9.29759 14.9456 9.23151 14.9897 9.17584 15.0454C9.12017 15.1011 9.07601 15.1671 9.04588 15.2399C9.01575 15.3126 9.00024 15.3906 9.00024 15.4693V18.4005C9.00024 18.7314 9.26882 19 9.59975 19H12.5309C12.6899 19 12.8424 18.9368 12.9549 18.8244C13.0673 18.712 13.1305 18.5595 13.1305 18.4005C13.1305 18.2415 13.0673 18.089 12.9549 17.9766C12.8424 17.8641 12.6899 17.801 12.5309 17.801H11.0466L13.443 15.4046C13.5019 15.3497 13.5491 15.2835 13.5819 15.2099C13.6147 15.1364 13.6323 15.057 13.6337 14.9765C13.6351 14.896 13.6203 14.8161 13.5902 14.7414C13.56 14.6668 13.5151 14.599 13.4582 14.542C13.4013 14.4851 13.3335 14.4402 13.2588 14.4101C13.1842 14.3799 13.1042 14.3651 13.0237 14.3665C12.9432 14.3679 12.8638 14.3856 12.7903 14.4183C12.7168 14.4511 12.6506 14.4983 12.5957 14.5572L10.1993 16.9521V15.4693Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoIntro;
